import { IconButton } from "@traas/lib/src/components/form/Button";
import { Input } from "@traas/lib/src/components/form/Input";
import {FC, useEffect, useState} from "react";
import {Employee} from "../../../lib/src/api/dto/Employee"
import {faSave} from "@fortawesome/free-solid-svg-icons";
import moment, {Moment} from "moment";
import {useApi} from "../api/APIContext";
import {useApiService} from "../../../lib/src/api/hooks/useApiService";
import {useNavigate} from "react-router";
import config from "../config";
import {getToken} from "@ventumsoftware/react-toolkit";
import {TimeRegistration} from "../../../lib/src/api/dto/TimeRegistration";

interface HoursInputProps {
  time?: TimeRegistration
  day: Moment
  employee: Employee
}

export const HoursInput: FC<HoursInputProps> = props => {
  const {timeRegistrationService} = useApiService(config, getToken, useNavigate())
  const {onHoursUpdated} = useApi()
  const [day, setDay] = useState(props.day)
  const [input, setInput] = useState<number|null>(null)
  const save = async () => {
    if (input !== null) {
      if (props.time) {
        await timeRegistrationService.update(props.time.id, props.employee.id, props.day.toDate(), input)
        await onHoursUpdated()
        setInput(null)
      } else {
        await timeRegistrationService.add(props.employee.id, props.day.toDate(), input)
        await onHoursUpdated()
        setInput(null)
      }
    }
  }

  useEffect(() => {
    if (moment(props.day).format('YYYY-MM-DD') !== moment(day).format('YYYY-MM-DD')) {
      setDay(props.day)
      setInput(null)
    }
  }, [props.day, day]);

  return <div className={'w-40 py-1 px-2 flex items-center'}>
    <div className={'-mt-1 flex-1 mr-2'}><Input type={'number'} min={-14} max={14} step={0.25} label={''} value={input ?? props.time?.hours ?? 0} onChange={(change) => {
      if (change === props.time?.hours) {
        setInput(null)
      } else {
        setInput(change)
      }
    }} /></div>
    <IconButton type={'primary'} disabled={input === null} onClick={save} icon={faSave} size={'md'} />
  </div>
}